/*
This is a logger object, all console log output should be sent through here
 */
export default class Logger {

	constructor() {
		this.level = 'DEBUG';

		this.DEBUG = 'DEBUG';
		this.INFO = 'INFO';
		this.WARNING = 'WARNING';
		this.ERROR = 'ERROR';
	}

	debug(caller, ...messages) {
		if (['DEBUG'].includes(this.level))
			this._log(caller, console.log, messages);
	}

	info(caller, ...messages) {
		if (['INFO', 'DEBUG'].includes(this.level))
			this._log(caller, console.log, messages);
	}

	warning(caller, ...messages) {
		if (['WARNING', 'INFO', 'DEBUG'].includes(this.level))
			this._log(caller, console.warn, messages);
	}

	error(caller, ...messages) {
		if (['ERROR', 'WARNING', 'INFO', 'DEBUG'].includes(this.level))
			this._log(caller, console.error, messages);
	}

	_stringify(o) {
		if (Array.isArray(o)) {
			let ret = '[ '
			for (const m in o) {
				ret += m + ": ";
				if (m.length && m.length > 0)
					ret += this._stringify(o[m]);
				else
					ret += o[m]
				ret += ' ';
			}
			ret += '] ';
			return ret;
		} else if (typeof o === "object") {
			let ret = '{ '
			for ( const m in o ) {
				ret += m + ": ";
				if (m.length && m.length > 0)
					ret += this._stringify(o[m]);
				else
					ret += o[m]
				ret += ' ';
			}
			ret += '} ';
			return ret;
		} else {
			return o + " ";
		}
	}

	_log(caller, fn, messages) {
		let component = caller.constructor.name;
		if (component === 'Function') {
			component = caller.name;
		}
		let log = '';
		if (messages.length && messages.length > 0) {
			for (let m of messages)
				log += this._stringify(m);
		} else {
			log = this._stringify(messages);
		}
		fn(`[${component}]`, log);
	}
}

